// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AddedToWishlistModal-module__content-table{margin:0 0 1rem}.AddedToWishlistModal-module__image-part{width:98px}.AddedToWishlistModal-module__image-part img{width:90px}", "",{"version":3,"sources":["webpack://./src/components/wishlist/Modals/AddedToWishlistModal.module.scss"],"names":[],"mappings":"AAAA,4CACE,eAAA,CAGF,yCACE,UAAA,CAEA,6CACE,UAAA","sourcesContent":[".content-table {\n  margin: 0 0 1rem;\n}\n\n.image-part {\n  width: 98px;\n\n  img {\n    width: 90px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content-table": "AddedToWishlistModal-module__content-table",
	"contentTable": "AddedToWishlistModal-module__content-table",
	"image-part": "AddedToWishlistModal-module__image-part",
	"imagePart": "AddedToWishlistModal-module__image-part"
};
export default ___CSS_LOADER_EXPORT___;
